var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$t('shop.order.info.cart')))]),_vm._v(" "),(_vm.products.length > 0)?_c('Products',{attrs:{"products":_vm.products}}):_vm._e(),_vm._v(" "),(_vm.activities.length > 0)?_c('Activities',{attrs:{"products":_vm.activities}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }